import { Component } from "@angular/core";
import { Camera, CameraOptions, PictureSourceType } from "@ionic-native/camera";
import {
  ActionSheetController,
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  Platform
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../providers/wh/summary-service";
import { WaybillOrderServiceProvider } from "../../../providers/qdb/qdb-service";
import {
  FileTransfer,
  FileUploadOptions,
  FileTransferObject
} from "@ionic-native/file-transfer";
import { Storage } from "@ionic/storage";
import { DatePipe } from "@angular/common";

@Component({
  selector: "profile-information-page",
  templateUrl: "index.html",
  providers: [SummaryServiceProvider, WaybillOrderServiceProvider, FileTransfer]
})
export class ProfileInformationPage {
  header_data: any;

  objectKeys = Object.keys;

  name: any;
  url: any;
  email: any;
  phoneNumber: any;

  constructor(
    private camera: Camera,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public waybillOrderService: WaybillOrderServiceProvider,
    public datepipe: DatePipe,
    private actionSheetController: ActionSheetController,
    public navParams: NavParams,
    private storage: Storage,
    platform: Platform,
    private transfer: FileTransfer,
    public summaryService: SummaryServiceProvider,
    public loadingCtrl: LoadingController
  ) {
    this.header_data = {
      ismenu: true,
      ishome: false,
      title: "Profile Information",
      parentReloadData: d => {
        // this.load_cp_data(true)
      }
    };

    this.displayProfileInfo();
  }

  displayProfileInfo() {
    this.summaryService
      .getProfileInfo("/api/v0.2/techsupport/users/profile")
      .then((res: any) => {
        let data = res.data;
        this.name = `${data.firstName} ${data.lastName}`;
        this.email = `${data.email}`;
        this.phoneNumber = `${data.phoneNumber}`;
        if (data.portrait) {
          this.url = `${data.portrait}`;
        } else {
          this.url =
            "https://cdn1.iconfinder.com/data/icons/social-messaging-productivity-1-1/128/gender-male2-512.png";
        }
      });
  }

  async selectImage() {
    const actionSheet = await this.actionSheetController.create({
      //header: "Select Image source",
      buttons: [
        {
          text: "Load from Library",
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: "Use Camera",
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: "Cancel",
          role: "cancel"
        }
      ]
    });
    await actionSheet.present();
  }

  takePicture(sourceType: PictureSourceType) {
    let fileTransfer: FileTransferObject = this.transfer.create();
    if (sourceType == this.camera.PictureSourceType.CAMERA) {
      let optionsCamera: CameraOptions = {
        quality: 100,
        targetWidth: 600,
        sourceType: this.camera.PictureSourceType.CAMERA,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE
      };

      this.camera.getPicture(optionsCamera).then(
        imageData => {
          let fileData = "data:image/jpeg;base64," + imageData;
          this.storage.get("jwt_token").then(jwt_token => {
            let headers = new Headers();
            headers.append("Authorization", "Bearer " + jwt_token);
            let options: FileUploadOptions = {
              fileKey: "picture",
              fileName: "name.jpg",
              chunkedMode: false,
              mimeType: "image/jpeg",
              headers: { Authorization: jwt_token }
            };
            fileTransfer
              .upload(
                fileData,
                this.summaryService.getApiUrl(`techsupport/users/portrait`),
                options
              )
              .then(
                data => {
                  this.displayProfileInfo();
                  console.log("file-upload-response=", data);
                },
                err => {
                  console.log("file-upload-response=", err);
                  // error
                }
              );
          });
        },
        err => {
          // Handle error
          console.log(err);
        }
      );
    }

    if (sourceType == this.camera.PictureSourceType.PHOTOLIBRARY) {
      let optionsGallery: CameraOptions = {
        quality: 100,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE
      };

      this.camera.getPicture(optionsGallery).then(
        async imageData => {
          //console.log("imageData", imageData);

          let fileData = "data:image/jpeg;base64," + imageData;

          this.storage.get("jwt_token").then(jwt_token => {
            let headers = new Headers();
            headers.append("Authorization", "Bearer " + jwt_token);

            let options: FileUploadOptions = {
              fileKey: "picture",
              fileName: "name.jpg",
              chunkedMode: false,
              mimeType: "image/jpeg",
              headers: { Authorization: jwt_token }
            };
            fileTransfer
              .upload(
                fileData,
                this.summaryService.getApiUrl(`techsupport/users/portrait`),
                options
              )
              .then(
                data => {
                  this.displayProfileInfo();
                  console.log("file-upload-response=", data);
                },
                err => {
                  console.log("file-upload-response=", err);
                  // error
                }
              );
          });
        },
        err => {
          // Handle error
          console.log(err);
        }
      );
    }
  }

  dataURItoBlob(dataURI) {
    return new Promise(async (resolve, reject) => {
      const byteString = atob(dataURI);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: "image/jpeg" });
      resolve(blob);
    });
  }

  // uploadFile(imageURI) {
  //   let loader = this.loadingCtrl.create({
  //     content: "Uploading..."
  //   });
  //   loader.present();
  //   const fileTransfer: FileTransferObject = this.transfer.create();

  //   let options: FileUploadOptions = {
  //     fileKey: 'ionicfile',
  //     fileName: 'ionicfile',
  //     chunkedMode: false,
  //     mimeType: "image/jpeg",
  //     headers: {}
  //   }

  //   fileTransfer.upload(imageURI, 'http://192.168.0.7:8080/api/uploadImage', options)
  //     .then((data) => {
  //       console.log(data + " Uploaded Successfully");
  //       //this.imageFileName = "http://192.168.0.7:8080/static/images/ionicfile.jpg"
  //       loader.dismiss();
  //       //this.presentToast("Image uploaded successfully");
  //     }, (err) => {
  //       console.log(err);
  //       loader.dismiss();
  //       //this.presentToast(err);
  //     });
  // }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/profile-information/index.ts